import React, { FC, HTMLAttributes } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/Reducers";
import { NewLoaderIcon } from "@/Utils/SVGExports/NewLoaderIcon";

interface PageLoaderProps extends HTMLAttributes<HTMLDivElement> {
  show: boolean;
  customStyles?: React.CSSProperties;
}

const PageLoader: FC<PageLoaderProps> = (props): JSX.Element | null => {
  const { customStyles = {} } = props;
  const { pageLoaderVisibility } = useSelector((state: RootState) => state.commonReducer);
  if (!props.show) {
    return null;
  }

  return pageLoaderVisibility ? 
    <div
      className="aspect-ratio--object flex justify-center items-center-ns tw-bg-white/10"
      style={{ zIndex: 10000, ...customStyles }}
    >
      <span className="flex items-center tw-animate-spin">
        <NewLoaderIcon />
      </span>
    </div>
   : null;
};

export default PageLoader;
